import React from "react";
import styled from "react-emotion";
// shared
import LegacyModal from "src/shared/LegacyModal";
import Button from "src/shared/Button";
// styles
import textStyles from "src/styles/textStyles";
import color from "src/styles/color";
// local
import InstallAppSvg from "./InstallAppSvg";

const Title = styled.div`
  ${textStyles("xlarge")};
  font-weight: bold;
`;

const Perimeter = styled.div`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LargeText = styled.div`
  ${textStyles("xxlarge")};
  font-weight: bold;
  margin: 32px 0 16px;
`;

const LightText = styled.div`
  ${textStyles("large")};
  color: ${color.gray3};
  margin-bottom: 40px;
  max-width: 360px;
  text-align: center;
`;

const UniformTeethAppModal = props => (
  <LegacyModal
    isOpen={props.isOpen}
    closeModal={props.handleClose}
    width="440px"
  >
    <LegacyModal.Title>
      <Title>Uniform Teeth App</Title>
    </LegacyModal.Title>
    <LegacyModal.Content>
      <Perimeter>
        <InstallAppSvg />
        <LargeText>It’s time to install the app!</LargeText>
        <LightText>
          Please guide the patient through the Uniform Teeth  app and answer any
          questions he/she may have.
        </LightText>
        <Button
          kind="primary"
          onClick={props.handleDone}
          style={{ width: "100px", height: "36px" }}
        >
          Done
        </Button>
      </Perimeter>
    </LegacyModal.Content>
  </LegacyModal>
);

export default UniformTeethAppModal;
